import { createAsyncThunk } from '@reduxjs/toolkit';
import { axios } from '@utils/lib';
import { Enums, Paths, Value } from '@utils/constants';
import {
  INotification,
  INotificationListQuery,
} from '@interfaces/components/notification';
import { IListRes } from '@interfaces/apis/response-data';
import { addLoading, removeLoading } from '../appAction';

export const getNotificationListAsync = createAsyncThunk(
  'notification/getList',
  async (query: INotificationListQuery, { rejectWithValue, dispatch }) => {
    if (query.isLoading) {
      dispatch(addLoading());
    }
    try {
      const searchQuery: Record<string, string> = {
        page: String(query.page ?? Value.TABLE_PAGE_INIT),
        pageSize: String(query.pageSize ?? Value.TABLE_PAGE_SIZE),
        order: 'DESC',
      };

      if (query?.isConfirmed !== undefined)
        searchQuery.isConfirmed = String(query.isConfirmed);

      const params = new URLSearchParams(searchQuery).toString();

      const { data } = await axios.request<IListRes<INotification>>(
        Enums.HTTP_METHOD.GET,
        Paths.NOTIFICATON + '?' + params
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      if (query.isLoading) {
        dispatch(removeLoading());
      }
    }
  }
);

export const getNotificationUnconfirmedCountAsync = createAsyncThunk(
  'notification/getUnconfirmedCount',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.request<{ count: number }>(
        Enums.HTTP_METHOD.GET,
        Paths.NOTIFICATON_COUNT
      );

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const confirmNotificationAsync = createAsyncThunk(
  'notification/confirm',
  async (id: string, { rejectWithValue }) => {
    try {
      await axios.request(
        Enums.HTTP_METHOD.PATCH,
        Paths.NOTIFICATON_CONFIRM.replace(':id', `${id}`)
      );

      return id;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const confirmAllNotificationAsync = createAsyncThunk(
  'notification/confirmAll',
  async (_, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PATCH,
        Paths.NOTIFICATON_CONFIRM_ALL
      );

      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const getNotificationByIdAsync = createAsyncThunk(
  'notification/getById',
  async (id: number, { rejectWithValue }) => {
    try {
      const { data } = await axios.request<INotification>(
        Enums.HTTP_METHOD.GET,
        `/notifications/${id}`
      );

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateNotificationAsync = createAsyncThunk(
  'notification/update',
  async (
    {
      id,
      body,
    }: {
      id: number;
      body: Partial<INotification>;
    },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.request<INotification>(
        Enums.HTTP_METHOD.PATCH,
        `/notifications/${id}`,
        body
      );

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteNotificationAsync = createAsyncThunk(
  'notification/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await axios.request(Enums.HTTP_METHOD.DELETE, `/notifications/${id}`);

      return id;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
